if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if(this.querySelector('.ctm-card-product-sub')){
          let pHandle = this.querySelector('.ctm-card-product-sub').dataset.handle;
          let sValue = this.querySelector('.ctm-card-product-sub').value;
          if(this.classList.contains('subscription-pro')){
            sValue = this.querySelectorAll('.ctm-card-product-sub option')[1].value;
          }
          if(pHandle == 'august-basics-box'){
            sValue = this.querySelectorAll('.ctm-card-product-sub option')[1].value;
          }else if(pHandle == 'the-full-august-experience'){
            sValue = this.querySelectorAll('.ctm-card-product-sub option')[2].value;
          }
          formData.append('selling_plan',sValue);
        }
        // return false;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
             // itg js
            if(document.querySelector('.show_quick')){
              document.querySelectorAll('.card_quick_variant').forEach(function(ele) {
                ele.classList.remove('show_quick');
              })
            }
            window.updateCartCount(response);
            // new
            if(this.dataset.setQty != 'false'){
              checkQty(response.id,this.dataset.setQty,false);
            }
            // itg js end
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


async function checkQty(itemId,setQty,itsRemove){
  if(document.querySelector('product-form[data-id="'+itemId+'"]')){
    let pForm = document.querySelector('product-form[data-id="'+itemId+'"]');
    if(itsRemove){
      pForm.querySelector('button[type="submit"]').removeAttribute('aria-disabled');
      pForm.querySelector('button[type="submit"]').removeAttribute('disabled');
      if(document.querySelector('.template-product')){
        pForm.querySelector('.pro-cart-text').innerHTML = 'add to cart';
      }else{
        pForm.querySelector('.pro-cart-text').innerHTML = 'Quick Add';
      }
    }else{
      let cartData = await getCart(); 
      let itemQuantity = 0;
      let inCart = false;
      for (let i = 0; i < cartData.items.length; i++) {
        let item = cartData.items[i];
        if(item.id == itemId){
          inCart = true;
          itemQuantity = itemQuantity + item.quantity;
        }
      }
      if(inCart){
        if(itemQuantity == setQty){
          pForm.querySelector('button[type="submit"]').setAttribute('aria-disabled',true);
          pForm.querySelector('button[type="submit"]').setAttribute('disabled',true);
          pForm.querySelector('.pro-cart-text').innerHTML = 'Already In Cart';
        }else{
          pForm.querySelector('button[type="submit"]').removeAttribute('aria-disabled');
          pForm.querySelector('button[type="submit"]').removeAttribute('disabled');
          if(document.querySelector('.template-product')){
            pForm.querySelector('.pro-cart-text').innerHTML = 'add to cart';
          }else{
            pForm.querySelector('.pro-cart-text').innerHTML = 'Quick Add';
          }
        }
      }
    }
  }
}